import { render } from "./TierEditDialog.vue?vue&type=template&id=5157285a"
import script from "./TierEditDialog.vue?vue&type=script&lang=js"
export * from "./TierEditDialog.vue?vue&type=script&lang=js"

import "./TierEditDialog.vue?vue&type=style&index=0&id=5157285a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__